/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/logok.png";
// import bgBack from "assets/images/rotating-card-bg-back.jpeg";
import logo from "assets/images/App.jpeg";
function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    Order Now
                    <br />
                    Wonderful
                  </>
                }
                description="Order the album online through our secure payment gateway powered by Kratos©"
              />
              <RotatingCardBack
                image={logo}
                title="Click Here"
                description="Fill out the details on the payment page to receive your copy"
                action={{
                  type: "external",
                  route: "https://paystack.com/pay/wonderful-album",
                  label: "order now",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  // icon="content_copy"
                  title="Who We Are"
                  description="We are the Williams Family, a South African Contemporary band
                  based in the city of Johannesburg"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  // icon="flip_to_front"
                  title="Our Sound"
                  description="A blend of modern tapestry of urban contemporary music masterfully 
                  blending rnb, rock, gospel, soul, jazz and dance genres"
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  // icon="price_change"
                  title="Original Lineup"
                  description="Cheryl S. Williams, Onzlo Juan Williams, Enzo Vaughan Williams &
                  Paul Edward Williams"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  // icon="devices"
                  title="Bookings & Enquiries"
                  description="Email - info.innersanctum@gmail.com
                  Mobile - (+27) 76 246 5819"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
